import React from 'react';
import { useLocation } from 'react-router-dom';
import LogoutButton from './LogoutButton';
import Section from './components/Section';
import Item from './components/Item';
import { FiHome, FiBriefcase, FiUsers, FiClipboard, FiMapPin, FiFileText, FiPackage, FiVideo, FiRadio, FiShoppingCart, FiLink, FiUpload ,FiRefreshCw} from 'react-icons/fi';
import { Accordion } from './components/Accordion';

export default function PsoSidebar() {
    const location = useLocation();

    return (
        <div className="flex h-screen flex-col bg-white text-gray-900 dark:bg-[#0f172a] dark:text-white">
            <div className="shrink-0 border-b border-gray-200 p-4 text-sm font-semibold dark:border-white/10">PSO Menu</div>
            <nav className="flex-1 overflow-y-auto p-2 text-sm">
                <Accordion defaultOpenId="branches">
                    <Section id="main" title="Main Menu" alwaysOpen>
                        <Item icon={FiHome} label="Dashboard" to="/dashboard" active={location.pathname === '/dashboard'} />
                    </Section>
                    <Section id="branches" title="Branches" subtitle="Manage Branch Information">
                        <Item icon={FiBriefcase} label="View Branches" to="/branches" active={location.pathname === '/branches'} />
                    </Section>
                    <Section id="management" title="Vendor Management" subtitle="Manage Service Companies">
                        <Item icon={FiUsers} label="Manage Vendors" to="/companies" active={location.pathname === '/companies'} />
                        <Item icon={FiUpload} label="Deployment Vendor" to="/deployments" active={location.pathname === '/deployments'} />
                        <Item icon={FiRefreshCw} label="Change of Vendor" to="/change-of-vendor" active={location.pathname === '/change-of-vendor'} />
                    </Section>
                    <Section id="surveys" title="Survey Management" subtitle="Manage Survey Operations">
                        <Item icon={FiClipboard} label="Branch Surveys" to="/surveys" active={location.pathname === '/surveys'} />
                        <Item icon={FiMapPin} label="New Location Surveys" to="/new-location-surveys" active={location.pathname === '/new-location-surveys'} />
                    </Section>
                    <Section id="request" title="Request" subtitle="Manage Request Forms">
                        <Item icon={FiFileText} label="Request Form" to="/request-form" active={location.pathname === '/request-form'} />
                    </Section>
                    <Section id="inventory" title="Manage Items" subtitle="Track and Manage Items">
                        <Item 
                            icon={FiPackage} 
                            label="CCTV Items" 
                            to="/inventory?category=CCTV" 
                            active={location.pathname === '/inventory' && new URLSearchParams(location.search).get('category') === 'CCTV'} 
                        />
                        <Item 
                            icon={FiPackage} 
                            label="BAMS Items" 
                            to="/inventory?category=BAMS" 
                            active={location.pathname === '/inventory' && new URLSearchParams(location.search).get('category') === 'BAMS'} 
                        />
                    </Section>
                    <Section id="manage-hardware" title="Hardware Management" subtitle="Track Hardware Installations and Shipments">
                        <Item icon={FiVideo} label="CCTV Hardware" to="/manage-hardware-cctv" active={location.pathname === '/manage-hardware-cctv'} />
                        <Item icon={FiRadio} label="BAMS Hardware" to="/manage-hardware-bams" active={location.pathname === '/manage-hardware-bams'} />
                    </Section>
                    <Section id="hardware" title="Hardware Request" subtitle="Manage CCTV and BAMS Hardware Requests">
                        <Item icon={FiVideo} label="CCTV" to="/cctv" active={location.pathname === '/cctv'} />
                        <Item icon={FiRadio} label="BAMS" to="/bams" active={location.pathname === '/bams'} />
                    </Section>
                    <Section id="purchase-order" title="Purchase Order" subtitle="Manage Purchase Orders">
                        <Item icon={FiShoppingCart} label="PO CCTV" to="/po-cctv" active={location.pathname === '/po-cctv'} />
                        <Item icon={FiShoppingCart} label="PO BAMS" to="/po-bams" active={location.pathname === '/po-bams'} />
                    </Section>
                </Accordion>
            </nav>
            <div className="shrink-0">
                <LogoutButton />
            </div>
        </div>
    );
}


